import { styled } from '@mui/material/styles';
import {
  TypographyPropertiesTitleStyled,
  TypographyPropertiesDataStyled,
} from './StyledComponents';

// Label/value stat-row atoms shared across the train stats popover and the
// packager completeness modal. A horizontal label-value pair with controlled
// spacing and responsive wrapping.
export const StatsRow = styled('div')({
  display: 'flex',
  marginBottom: '12px',
  '&:last-child': {
    marginBottom: 0,
  },
});

export const StatsLabel = styled(TypographyPropertiesTitleStyled)({
  minWidth: '120px',
  flexShrink: 0,
});

export const StatsValue = styled(TypographyPropertiesDataStyled)({
  flexWrap: 'wrap',
});
